import { LanguageCode } from '@headless-workspace/config';
import { z } from 'zod';

export const MiniSizeConfigDTO = z.record(z.nativeEnum(LanguageCode), z.record(z.string(), z.string()));
